import React from 'react';
import Link from 'components/link';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import { gaps } from 'components/layout/stack';
import MobileOnly from 'utils/mobile_only';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${props => props.isMobile ? 'space-between' : 'center'};
  background: ${props => props.selected ? '#DDD' : '#FFF'};
  color: ${props => props.color};
  font-weight: ${props => props.isMobile ? 'normal' : 'bold'};
  cursor: pointer;
  column-gap: ${gaps.xs};
  height: ${props => props.isMobile ? '54px' : '68px'};
  display: flex;
  position: relative;
  margin: 0;
  border-bottom: 1px solid #e8e8e8;
  font-size: ${props => props.isMobile ? '16px' : '14px'};
  padding: ${props => props.isMobile ? '0 16px' : '0 10px'};
  box-sizing: border-box;
  &:hover {
    background: #DDD;
  }

  i {
    margin-top: 2.5px;
  }
`;

const SettingsMenuRow = props => {
  const content = (
    <Row
      selected={props.selected}
      onClick={props.onClick}
      isMobile={AppUI.layout.isMobile}
      color={props.color}
    >
      {props.children}
      {
        !props.hideCaret &&
          <MobileOnly>
            <i className='fa fa-chevron-right' />
          </MobileOnly>
      }
    </Row>
  );

  if (props.to) {
    return <Link to={props.to}>{content}</Link>;
  }
  return content;
};

export default SettingsMenuRow;